/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetCreateFiltersModel {
    getFixupPrototypeFunction() { return BudgetCreateFiltersModel.fixupPrototype; }

    static newInstance(model: Partial<BudgetCreateFiltersModel>): BudgetCreateFiltersModel {
        let obj = Object.assign(new BudgetCreateFiltersModel(), model);
        BudgetCreateFiltersModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetCreateFiltersModel>): BudgetCreateFiltersModel {
        if (!model) return null;
        return BudgetCreateFiltersModel.newInstance(<BudgetCreateFiltersModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetCreateFiltersModel) {
        if (!obj) return;

        models.BudgetCreateFiltersModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetCreateFiltersModel): boolean {
        Object.setPrototypeOf(obj, BudgetCreateFiltersModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resource_type) {
            for (let val of this.resource_type) {
                models.FilterIdNameModel.fixupPrototype(val);
            }
        }
    }

    /**
     * resource_type with id name. Id and name can be obtained from /budget/filter_values API
     */
    resource_type: Array<models.FilterIdNameModel>;

    /**
     * tag filter values.Format should key nad list of values
     */
    tags: any;

}
